import styled from 'styled-components';

export default styled.div`
  color: #f6fdff;
  font-size: 14px;
`;
